import { useSubscription } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { isAuthenticated } from "@src/auth/auth-utils";
import { graphql } from "@src/gql";
import { useQueryClient } from "@tanstack/react-query";
import { type Plan, planSchema } from "../plan-schemas";
import { planQueryKeys } from "../queries/query-keys";

export const planStatusQuery = graphql(/* GraphQL */ `
  subscription PlanStatusSubscription {
		planStatus {
			event {
				payload {
					...PlanDocumentFragment
				}
			}
		}
	}
`);

export function usePlanStatus() {
	const queryClient = useQueryClient();

	useSubscription(planStatusQuery, {
		skip: !isAuthenticated(),
		onData: ({ data }) => {
			if (data.data) {
				const payload = data.data?.planStatus?.event?.payload;

				if (payload) {
					// Validate payload against the Zod schema
					const parsedPayload = planSchema.safeParse(payload);

					if (parsedPayload.success) {
						// Type-safe payload update
						const validatedPayload: Plan = parsedPayload.data;

						queryClient.setQueriesData<Plan>(
							{ queryKey: ["myPlan"] },
							validatedPayload,
						);

						queryClient.refetchQueries({
							queryKey: planQueryKeys.allMyPlanEntityMetered,
						});
					} else {
						console.error("Invalid payload", parsedPayload.error);
						Sentry.captureException(parsedPayload.error);
					}
				}
			}
		},
	});
}
